/* Accueil Eliorane : comportements des sections lc-home-* (code écrit pour ce thème).
   - images à chargement différé : fondu une fois chargées (classe .loaded)
   - <use-animate> : l'attribut animate est posé quand l'élément entre à l'écran
   - <slider-scroll-component> : défilement lent automatique sur ordinateur (le glissement : lc-drag-scroll.js)
   - diaporama : barres de pagination, glisser souris et doigt, rotation automatique */
(function () {
  if (window.__lcAccueil) return;
  window.__lcAccueil = true;
  document.documentElement.classList.add('js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- images ---- */
  function imgDone(img) {
    img.classList.add('loaded');
    var wrap = img.closest('.loading');
    if (wrap) wrap.classList.remove('loading');
  }
  var offObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('lc-off', !e.isIntersecting); });
  }, { rootMargin: '300px 0px' }) : null;
  function watchImg(img) {
    if (img.__lcWatched) return;
    img.__lcWatched = true;
    /* la barre de chargement n'anime que les images proches de l'écran : hors champ elle tournait à l'infini pour rien (coût en WebKit mobile) */
    var lw = img.closest('.loading');
    if (lw && offObs) offObs.observe(lw);
    if (img.complete && img.naturalWidth) { imgDone(img); return; }
    img.addEventListener('load', function () { imgDone(img); });
    img.addEventListener('error', function () { imgDone(img); });
  }
  function scanImages(root) {
    (root || document).querySelectorAll('img[is="lazy-image"]').forEach(watchImg);
  }

  /* ---- use-animate ---- */
  var seen = (!reduceMotion && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.setAttribute('animate', '');
      seen.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -50px 0px', threshold: 0.05 }) : null;

  if (!customElements.get('use-animate')) {
    customElements.define('use-animate', class extends HTMLElement {
      connectedCallback() {
        if (reduceMotion || !seen) {
          this.setAttribute('animate', '');
        } else {
          seen.observe(this);
        }
      }
    });
  }

  /* ---- carrousel de produits ----
     Défilement lent automatique sur ordinateur (mesuré sur lancaster.com : environ 20 px/s), arrêté pendant le survol
     exactement à la position atteinte (l'accroche est désactivée à la souris, voir le CSS). Le glissement à la souris
     est dans lc-drag-scroll.js. À la fin de la liste, le défilement s'arrête (comme la référence). */
  var AUTO_SPEED = 0.02; /* px par milliseconde (20 px/s, avancée mesurée équivalente à lancaster.com) */

  if (!customElements.get('slider-scroll-component')) {
    customElements.define('slider-scroll-component', class extends HTMLElement {
      connectedCallback() {
        var list = this.querySelector('.slider-scroll');
        if (!list || list.__lcSlider) return;
        list.__lcSlider = true;
        this.setup(list);
      }
      setup(list) {
        /* Défilement automatique sur le compositeur : les <li> glissent par une animation transform (Web Animations),
           pas par scrollLeft écrit à chaque image, donc aucune saccade même quand les scripts tiers occupent le fil
           principal. scrollLeft reste figé pendant l'animation ; commit() le met à jour dès qu'un autre geste
           (glisser, doigt, molette, focus) a besoin de la position réelle. */
        var anims = [], visible = false, hovering = false, dragging = false;
        var desktop = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

        function offset() { return anims.length ? (anims[0].currentTime || 0) * AUTO_SPEED : 0; }
        function commit() {
          if (!anims.length) return;
          var off = offset();
          anims.forEach(function (a) { a.cancel(); });
          anims = [];
          list.scrollLeft = list.scrollLeft + off;
        }
        function pause() { anims.forEach(function (a) { a.pause(); }); }
        function play() {
          if (hovering || dragging || reduceMotion || !visible || !desktop.matches || document.hidden) return;
          if (anims.length) { anims.forEach(function (a) { a.play(); }); return; }
          var remaining = list.scrollWidth - list.clientWidth - list.scrollLeft;
          if (remaining < 1 || !list.animate) return;
          var frames = [{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-remaining) + 'px)' }];
          anims = Array.prototype.map.call(list.children, function (li) {
            return li.animate(frames, { duration: remaining / AUTO_SPEED, easing: 'linear', fill: 'forwards' });
          });
          if (anims.length) anims[0].onfinish = function () { commit(); }; /* fin de liste : on s'arrête, comme la référence */
        }

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible) play(); else pause();
          }, { threshold: 0.3 }).observe(list);
        }
        list.addEventListener('mouseenter', function () { hovering = true; pause(); }); /* arrêt exact, sans saut */
        list.addEventListener('mouseleave', function () { hovering = false; play(); });
        /* tout geste qui lit ou écrit scrollLeft recale d'abord la position (avant lc-drag-scroll.js : phase de capture) */
        this.addEventListener('mousedown', commit, true);
        this.addEventListener('wheel', commit, { capture: true, passive: true });
        list.addEventListener('lcdragstart', function () { dragging = true; commit(); });
        list.addEventListener('lcdragend', function () { dragging = false; play(); });
        list.addEventListener('focusin', commit);
        list.addEventListener('focusout', play);
        list.addEventListener('touchstart', commit, { passive: true });
        document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });
        window.addEventListener('resize', function () { commit(); play(); });
      }
    });
  }

  /* ---- diaporama ----
     Comme lancaster.com (Flickity) : les photos de la couche droite glissent d'une diapositive à l'autre avec la physique de
     Flickity (attraction 0,025, frottement 0,28, boucle infinie, glisser souris ou doigt, seuil 10 px) ; les textes, eux, ne
     bougent pas : chaque carte se fond (opacité 0,25 s, délai 0,1 s) et ses lignes glissent en entrant (voir le CSS).
     Les photos de Lancaster ne montrent pas de parallaxe : leur règle transform: scale(1,1) !important écrase le décalage.
     Initialisé sur .slideshow (le thème de base définit déjà une balise slideshow-component). */
  var ATTRACTION = 0.025, FRICTION = 0.28, FRAME = 1000 / 60;

  function Slideshow(root) {
    var self = this;
    this.root = root;
    var layers = ['.slideshow__left', '.slideshow__content', '.slideshow__right'].map(function (sel) {
      var layer = root.querySelector(sel);
      return layer ? layer.querySelector('.flickity-slider') : null;
    });
    this.contentTrack = layers[1];
    this.imageTrack = layers[2];
    if (!this.contentTrack || !this.imageTrack) return;
    this.cells = layers.filter(Boolean).map(function (track) { return Array.prototype.slice.call(track.children); });
    this.imageCells = Array.prototype.slice.call(this.imageTrack.children);
    this.count = this.imageCells.length;
    if (!this.count) return;
    this.index = 0;
    this.p = 0; this.v = 0; this.target = 0; this.anim = null;
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.flickity-page-dot'));
    this.dots.forEach(function (dot, k) { dot.addEventListener('click', function () { self.go(k, true); }); });

    this.cells.forEach(function (list) {
      list.forEach(function (cell) { cell.style.cssText += ';position:absolute;left:0;top:0;width:100%'; });
    });
    this.layout();
    this.render();

    /* glisser (souris ou doigt) : les photos suivent le pointeur (seuil 10 px comme dragThreshold de Lancaster),
       la diapositive change si le geste dépasse 40 px. */
    var startX = null, startP = 0, dx = 0, dragging = false, pid = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.button > 0 || e.target.closest('.flickity-page-dot')) return;
      startX = e.clientX; startP = self.current().p; dx = 0; dragging = false; pid = e.pointerId; self.swiped = false;
    });
    root.addEventListener('pointermove', function (e) {
      if (startX === null || e.pointerId !== pid) return;
      dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 10) {
        dragging = true;
        root.classList.add('is-dragging');
        self.sync(); self.v = 0;
        try { root.setPointerCapture(pid); } catch (err) { /* sans importance */ }
      }
      if (dragging) {
        clearInterval(self.timer);
        self.p = startP - dx / (root.clientWidth || 1);
        self.layout();
      }
    });
    function release(e) {
      if (startX === null || (e && e.pointerId !== pid)) return;
      var moved = dragging, d = dx;
      startX = null; dragging = false; dx = 0;
      root.classList.remove('is-dragging');
      try { root.releasePointerCapture(pid); } catch (err) { /* sans importance */ }
      if (moved) {
        self.swiped = true;
        self.go(self.index + (Math.abs(d) > 40 ? (d < 0 ? 1 : -1) : 0), true);
      }
    }
    /* un glissement ne doit pas suivre le lien de l'image */
    root.addEventListener('click', function (e) { if (self.swiped) { e.preventDefault(); e.stopPropagation(); self.swiped = false; } }, true);
    root.addEventListener('pointerup', release);
    root.addEventListener('pointercancel', release);
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    this.schedule();
  }
  /* position de chaque photo : écart à la position courante, ramené à la plus courte distance (boucle infinie) */
  Slideshow.prototype.layout = function () {
    var n = this.count, p = this.p;
    this.imageCells.forEach(function (cell, k) {
      var d = ((k - p) % n + n) % n;
      if (d > n / 2) d -= n;
      cell.style.transform = 'translateX(' + (d * 100) + '%)';
    });
  };
  /* Le ressort de Flickity est calculé d'un coup (mêmes constantes, une valeur par image à 60 Hz) puis rejoué comme animation
     transform (Web Animations) : le glissement tourne sur le compositeur et reste fluide même quand les scripts tiers
     bloquent le fil principal. Les cellules gardent en ligne la position d'arrivée ; l'animation passe par-dessus. */
  Slideshow.prototype.animate = function () {
    var self = this, n = this.count;
    this.sync();
    var P = [this.p], V = [this.v], p = this.p, v = this.v, i = 0;
    while (i < 240) {
      p += v; v += (this.target - p) * ATTRACTION; v *= 1 - FRICTION; i++;
      P.push(p); V.push(v);
      if (Math.abs(this.target - p) < 0.0005 && Math.abs(v) < 0.0005) break;
    }
    P[P.length - 1] = this.target; V[V.length - 1] = 0;
    var last = P.length - 1;
    var anims = this.imageCells.map(function (cell, k) {
      var frames = [], prev = null;
      P.forEach(function (pos, j) {
        var d = ((k - pos) % n + n) % n;
        if (d > n / 2) d -= n;
        var offset = j / last;
        /* une cellule qui change de côté (hors écran) saute : deux images clés au même instant */
        if (prev !== null && Math.abs(d - prev) > n / 2) frames.push({ offset: offset, transform: 'translateX(' + (prev * 100) + '%)' });
        frames.push({ offset: offset, transform: 'translateX(' + (d * 100) + '%)' });
        prev = d;
      });
      return cell.animate(frames, { duration: last * FRAME, easing: 'linear' });
    });
    this.anim = { list: anims, P: P, V: V, last: last };
    this.p = this.target; this.v = 0; this.layout();
    anims[0].onfinish = function () { if (self.anim && self.anim.list === anims) { anims.forEach(function (a) { a.cancel(); }); self.anim = null; } };
  };
  /* état courant (position, vitesse) : celui de l'animation en cours, sinon l'état stocké */
  Slideshow.prototype.current = function () {
    var a = this.anim;
    if (!a) return { p: this.p, v: this.v };
    var f = Math.min(Math.max((a.list[0].currentTime || 0) / FRAME, 0), a.last), i = Math.floor(f), u = f - i, j = Math.min(i + 1, a.last);
    return { p: a.P[i] + (a.P[j] - a.P[i]) * u, v: a.V[i] + (a.V[j] - a.V[i]) * u };
  };
  Slideshow.prototype.sync = function () {
    if (!this.anim) return;
    var c = this.current();
    this.anim.list.forEach(function (x) { x.cancel(); });
    this.anim = null;
    this.p = c.p; this.v = c.v; this.layout();
  };
  Slideshow.prototype.render = function () {
    var i = this.index;
    this.cells.forEach(function (list) {
      list.forEach(function (cell, k) {
        cell.classList.toggle('is-selected', k === i);
        cell.classList.toggle('is-previous', k < i);
        cell.classList.toggle('is-next', k > i);
        cell.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
    });
    this.dots.forEach(function (dot, k) {
      dot.classList.toggle('is-selected', k === i);
      if (k === i) dot.setAttribute('aria-current', 'step'); else dot.removeAttribute('aria-current');
    });
    /* la diapositive affichée ne doit plus attendre son chargement différé */
    this.imageCells[i].querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
  };
  Slideshow.prototype.go = function (k, byUser) {
    var self = this, n = this.count;
    var next = ((k % n) + n) % n;
    var delta = next - this.index;
    if (delta > n / 2) delta -= n; else if (delta < -n / 2) delta += n;
    this.index = next;
    this.target = Math.round(this.target) + delta;
    this.render();
    if (reduceMotion || !this.imageCells[0].animate) { this.sync(); this.p = this.target; this.v = 0; this.layout(); }
    else this.animate();
    if (byUser) this.schedule();
  };
  Slideshow.prototype.schedule = function () {
    var self = this;
    clearInterval(this.timer);
    if (this.root.dataset.autorotate !== 'true') return;
    var delay = parseInt(this.root.dataset.autorotateSpeed, 10) || 5000;
    this.timer = setInterval(function () {
      if (!document.hidden) self.go(self.index + 1, false);
    }, delay);
  };

  function initSlideshows(root) {
    (root || document).querySelectorAll('.slideshow').forEach(function (el) {
      if (el.__lcSlideshow) return;
      el.__lcSlideshow = true;
      new Slideshow(el);
    });
  }

  function init(root) { scanImages(root); initSlideshows(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
